<template>
  <div class="welcomeView">
    <div class="top">
      <div class="left">
        <h3>项目管理</h3>
        <div class="title-box">
          <div
            class="content"
            v-for="(item, index) in ProjectManagementList"
            :key="index"
          >
            <div class="name">{{ item.name }}</div>
            <div
              class="value"
              @click="Skip(item.img.split('xmgl-')[1].split('.')[0])"
            >
              <div class="number">{{ item.count }}个</div>
              <div class="icon">
                <img :src="item.img" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="title-box">
          <div class="content">
            <div class="name">
              {{ username }}&nbsp;您好，欢迎使用新美云平台！
            </div>
            <div class="date">当前时间：{{ $root.formatDate(time) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="center">
      <h3>审批管理</h3>
      <div class="center-box">
        <div class="left-box">
          <div class="one-box">
            <div class="notification">
              <div class="bubble" @click="activeName = 'Wait'">
                {{ Newstotal >= 100 ? "99+" : Newstotal }}
              </div>
              <div class="bubble1" @click="activeName = 'Send'">
                {{ CopyNewtotal >= 100 ? "99+" : CopyNewtotal }}
              </div>
              <template>
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="待办" name="Wait">
                    <welcomeViewApproveVue :WaitList="NewsList">
                    </welcomeViewApproveVue>
                  </el-tab-pane>
                  <el-tab-pane label="抄送我" name="Send">
                    <welcomeViewApproveVue :WaitList="CopyNewsList">
                    </welcomeViewApproveVue>
                  </el-tab-pane>
                  <el-tab-pane label="已发起" name="initiate"></el-tab-pane>
                </el-tabs>
              </template>
            </div>
            <div class="request">
              <div class="head">
                <div class="icon">
                  <img
                    style="width: 100%; height: 100%"
                    src="https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/faqishenqing_30x30.png"
                    alt=""
                  />
                </div>
                <div class="name">发起申请</div>
              </div>
              <div class="centerBOX">
                <div
                  class="value"
                  v-for="(item, index) in requestList"
                  :key="index"
                  @click="SkipAdd(item.src.split('fqsq-')[1].split('.')[0])"
                >
                  <div class="centerIcon">
                    <img
                      style="width: 100%; height: 100%"
                      :src="item.src"
                      alt=""
                    />
                  </div>
                  <div class="centerName">{{ item.name }}</div>
                </div>
              </div>
            </div>
          </div>
          <h3>我的应用</h3>
          <div class="two-box">
            <div
              class="content"
              v-for="(item, index) in SkipList"
              :key="index"
              @click="Skip(item.src.split('app-')[1].split('.')[0])"
            >
              <div class="icon">
                <img style="width: 100%; height: 100%" :src="item.src" alt="" />
              </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <template>
            <el-tabs v-model="activeName1" @tab-click="handleClick1">
              <el-tab-pane label="公告通知" name="message" lazy>
                <welcomeViewModulesVue
                  :institutionList="COMP_NOTICELIST"
                ></welcomeViewModulesVue>
              </el-tab-pane>
              <el-tab-pane label="公司新闻" name="news" lazy>
                <welcomeViewModulesVue
                  :institutionList="COMP_NEWSLIST"
                ></welcomeViewModulesVue>
              </el-tab-pane>
              <el-tab-pane label="制度公告" name="announcement" lazy>
                <welcomeViewModulesVue
                  :institutionList="COMP_INSTLIST"
                ></welcomeViewModulesVue>
              </el-tab-pane>
            </el-tabs>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomeViewModulesVue from "../components/welcomeViewModules.vue";
import * as Urls from "../helper/Urls";
import welcomeViewApproveVue from "../components/welcomeViewApprove.vue";
export default {
  components: { welcomeViewModulesVue, welcomeViewApproveVue },
  data() {
    return {
      activeName: "Wait",
      activeName1: "message",
      ProjectManagementList: [],
      SkipList: [
        {
          name: "登记立项",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-djlx.png",
        },
        {
          name: "在跟项目",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zgxm.png",
        },
        {
          name: "在建项目",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zjxm.png",
        },
        {
          name: "完工项目",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-wgxm.png",
        },
        {
          name: "合同管理",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-htgl.png",
        },
        {
          name: "资料管理",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-zlgl.png",
        },
        {
          name: "项目用印",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-xmyy.png",
        },
        {
          name: "材料代付",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-cldf.png",
        },
        {
          name: "劳务支付",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-lwzf.png",
        },
        {
          name: "财务管理",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/app-cwgl.png",
        },
      ],
      requestList: [
        {
          name: "项目用印",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-xiangmuyongyin.png",
        },
        {
          name: "其他用印",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-qitayongyin.png",
        },
        {
          name: "劳务支付",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-laowuzhifu.png",
        },
        {
          name: "代付材料",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-daifucailiao.png",
        },
        {
          name: "登记立项",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-dengjilixiang.png",
        },
        {
          name: "开票申请",
          src: "https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/fqsq-kaipiaoshengqing.png",
        },
      ],
      NewsList: [],
      CopyNewsList: [],
      COMP_NOTICELIST: [],
      COMP_NEWSLIST: [],
      COMP_INSTLIST: [],
      Newstotal: 0,
      CopyNewtotal: 0,
      username: "",
      time: "",
      timeId: null,
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("user"));
    this.username = userInfo.realName;
    this.getNews();
    this.getCopyNews();
    this.getworkbench_data();
    this.getSystemNoticePage("COMP_NOTICE");
  },
  methods: {
    handleClick1(value, e) {
      switch (value.name) {
        case "message":
          this.getSystemNoticePage("COMP_NOTICE");
          break;
        case "news":
          this.getSystemNoticePage("COMP_NEWS");
          break;
        case "announcement":
          this.getSystemNoticePage("COMP_INST");
          break;
      }
    },
    Skip(value) {
      switch (value) {
        case "djlx":
          this.$router.push("/common/projectPreparation");
          break;
        case "zgxm":
          this.$router.push("/cm/project/followUpProject");
          break;
        case "zjxm":
          this.$router.push("/cm/project/underConstructionProject");
          break;
        case "wgxm":
          this.$router.push("/cm/project/finishedProject");
          break;
        case "htgl":
          this.$router.push("/common/CMcontractData");
          break;
        case "zlgl":
          this.$router.push("/common/fileList");
          break;
        case "xmyy":
          this.$router.push("/cm/sealApplicationIndexView");
          break;
        case "cldf":
          this.$router.push("/common/materialList");
          break;
        case "lwzf":
          this.$router.push("/common/servicePayList2");
          break;
        case "cwgl":
          this.$router.push("/fm/FMStatProjectIndexView");
          break;
      }
    },
    SkipAdd(value) {
      switch (value) {
        case "xiangmuyongyin":
          this.$router.push({
            path: "/cm/sealApplicationIndexView",
            query: {
              mark: true,
            },
          });
          break;
        case "qitayongyin":
          this.$router.push("/cm/sealApplicationOtheradd");
          break;
        case "laowuzhifu":
          this.$router.push({
            path: "/common/servicePayList",
            query: {
              mark: true,
            },
          });
          break;
        case "daifucailiao":
          this.$router.push({
            path: "/common/materialList",
            query: {
              mark: true,
            },
          });
          break;
        case "dengjilixiang":
          this.$router.push("/common/proPreparationAdd");
          break;
        case "kaipiaoshengqing":
          this.$router.push({
            path: "/fm/FmOutPutTicket",
            query: {
              mark: true,
            },
          });
          break;
      }
    },
    handleClick(value, e) {
      switch (value.name) {
        case "Wait":
          this.getNews();
          break;
        case "Send":
          this.getCopyNews();
          break;
      }
    },
    // 待办
    getNews() {
      let inst = this;
      let url = Urls.message_unreadMsgPage;
      let params = {
        pageNo: 1,
        pageSize: 3,
      };
      this.$root.doPost(url, params, function (server_data) {
        // 用户没有登录
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }
        // 应用错误
        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.NewsList = server_data.data.dataList;
        inst.Newstotal = server_data.data.totalCount;
      });
    },
    // 抄送
    getCopyNews() {
      let inst = this;
      let url = Urls.message_unreadCopyMsgPage;
      let params = {
        pageNo: 1,
        pageSize: 3,
        isAwait: "Y",
      };
      this.$root.doPost(url, params, function (server_data) {
        // 用户没有登录
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }
        // 应用错误
        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.CopyNewsList = server_data.data.dataList;
        inst.CopyNewtotal = server_data.data.totalCount;
      });
    },
    getSystemNoticePage(value) {
      let inst = this;
      let url = Urls.NoticeGetSystemNoticePage;
      let params = {
        pageNo: 1,
        pageSize: 5,
        noticeType: value,
      };
      this.$root.doPost(url, params, function (server_data) {
        // 用户没有登录
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }
        // 应用错误
        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        if (value === "COMP_NOTICE") {
          inst.COMP_NOTICELIST = server_data.data.dataList;
        } else if (value === "COMP_NEWS") {
          inst.COMP_NEWSLIST = server_data.data.dataList;
        } else {
          inst.COMP_INSTLIST = server_data.data.dataList;
        }
      });
    },
    getworkbench_data() {
      let inst = this;
      let url = Urls.workbench_data;
      let params = {};
      this.$root.doPost(url, params, function (server_data) {
        // 用户没有登录
        if (!inst.$root.isUserLogin(server_data)) {
          return;
        }
        // 应用错误
        if (server_data.error) {
          inst.$root.showGlobalError(server_data.error);
          return;
        }
        inst.ProjectManagementList = server_data.data;
      });
    },
  },
  mounted() {
    this.timeId = setInterval(() => {
      this.time = new Date();
    }, 1000);
  },
  beforeDestroy() {
    this.timeId && clearInterval(this.timeId);
  },
};
</script>

<style lang="scss" scoped>
.welcomeView {
  margin-top: 14px;

  .top {
    display: flex;

    .left {
      width: 60%;
      margin-right: 30px;

      .title-box {
        display: flex;
        width: 100%;
        height: 100px;
        justify-content: space-between;

        .content {
          width: 23%;
          background-color: #fff;
          -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          border-radius: 9px;

          .name {
            margin: 15px 0 0px 10px;
            font-size: 14px;
          }

          .value {
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;

            .number {
              margin-left: 10px;
              font-weight: 700;
              font-size: 18px;
            }

            .icon {
              height: 48px;
              width: 48px;
              margin-right: 35px;

              img {
                height: 100%;
                width: 100%;
              }
            }
          }
        }
      }
    }

    .right {
      flex: 1;
      padding-top: 56px;

      .title-box {
        height: 100px;
        background-image: url("https://xmyun.zhoty.com/xmerp/pcadmin/static/images/workbench/banner.png");
        overflow: hidden;
        border-radius: 9px;

        .content {
          margin-left: 210px;
          margin-top: 20px;

          .name {
            font-size: 18px;
            color: #fff;
            margin-bottom: 10px;
          }

          .date {
            color: #fff;
          }
        }
      }
    }
  }

  .center {
    height: 600px;

    .center-box {
      display: flex;
      height: 100%;

      .left-box {
        width: 60%;
        margin-right: 30px;

        .one-box {
          width: 100%;
          height: 60.5%;
          display: flex;

          .notification {
            position: relative;
            padding: 20px 20px 15px 20px;
            box-sizing: border-box;
            width: 55%;
            background-color: #fff;
            border-radius: 9px;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            margin-right: 25px;

            .bubble,
            .bubble1 {
              position: absolute;
              top: 10px;
              z-index: 999;
              left: 40px;
              height: 18px;
              width: 30px;
              background: red;
              color: #fff;
              border-radius: 15px 15px;
              text-align: center;
              line-height: 18px;
              font-size: 12px;
              cursor: pointer;
            }

            .bubble1 {
              background: #ccc;
              left: 102px;
            }
          }

          .request {
            width: 45%;
            background-color: #fff;
            padding: 20px 20px 15px 20px;
            border-radius: 9px;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            .head {
              display: flex;
              align-items: center;

              .icon {
                height: 30px;
                width: 30px;
              }

              .name {
                margin-left: 10px;
                font-size: 16px;
                font-weight: 600;
              }
            }

            .centerBOX {
              display: flex;
              flex-wrap: wrap;
              width: 100%;
              margin-top: 30px;

              .value {
                display: flex;
                align-items: center;
                width: 50%;
                margin-bottom: 40px;
                cursor: pointer;

                .centerIcon {
                  height: 50px;
                  width: 50px;
                }

                .centerName {
                  margin-left: 10px;
                  font-size: 14px;
                }
              }
            }
          }
        }

        .two-box {
          width: 100%;
          height: 30%;
          padding: 18px;
          padding-left: 21px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          align-content: space-around;
          background-color: #fff;
          border-radius: 9px;
          -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

          .content {
            display: flex;
            align-items: center;
            cursor: pointer;
            width: 17%;
            padding: 15px;
            margin: 0 14px 0 14px;
            box-sizing: border-box;
            background-color: #fff;
            border-radius: 9px;
            -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

            .icon {
              height: 35px;
              width: 35px;
              margin-right: 15px;
            }

            .name {
              font-size: 15px;
            }

            &:nth-child(n + 1):nth-child(-n + 5) {
              margin-bottom: 7px;
            }

            &:nth-child(n + 6):nth-child(-n + 10) {
              margin-top: 7px;
            }
          }
        }
      }

      .right {
        flex: 1;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        background-color: #fff;
        border-radius: 9px;
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>
<style lang="scss">
.welcomeView {
  .el-tabs__nav-wrap::after {
    background: #fff !important;
  }

  .center-box {
    .left-box {
      .one-box {
        .el-tabs__content {
          height: 276px;
        }
      }
    }
  }

  .center-box {
    .right {
      .el-tabs__content {
        height: 510px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// welcomeView.vue?3d757e0a